// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.BiNetworkChart = function BiNetworkChart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M19,3c-1.654,0-3,1.346-3,3c0,0.502,0.136,0.968,0.354,1.385l-1.116,1.302C14.599,8.254,13.829,8,13,8 c-0.739,0-1.425,0.216-2.02,0.566L9.566,7.152C9.834,6.658,10,6.101,10,5.5C10,3.57,8.43,2,6.5,2S3,3.57,3,5.5S4.57,9,6.5,9 c0.601,0,1.158-0.166,1.652-0.434L9.566,9.98C9.216,10.575,9,11.261,9,12c0,0.997,0.38,1.899,0.985,2.601l-1.692,1.692l0.025,0.025 C7.919,16.121,7.476,16,7,16c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3c0-0.476-0.121-0.919-0.318-1.318l0.025,0.025 l1.954-1.954C12.082,15.903,12.528,16,13,16c2.206,0,4-1.794,4-4c0-0.645-0.168-1.245-0.439-1.785l1.253-1.462 C18.178,8.911,18.578,9,19,9c1.654,0,3-1.346,3-3S20.654,3,19,3z M7,20c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1 S7.552,20,7,20z M5,5.5C5,4.673,5.673,4,6.5,4S8,4.673,8,5.5S7.327,7,6.5,7S5,6.327,5,5.5z M13,14c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,14,13,14z M19,7c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S19.552,7,19,7z"
      }
    }]
  })(props);
};